var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsObject, IsString } from 'class-validator';
export class AddressValidationResponseComponent {
    changed;
    newValue;
    confirmationLevel;
}
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], AddressValidationResponseComponent.prototype, "changed", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], AddressValidationResponseComponent.prototype, "newValue", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], AddressValidationResponseComponent.prototype, "confirmationLevel", void 0);
export class AddressValidationResponseDto {
    canBeAutoCorrected;
    needsCorrection;
    street;
    zip;
    town;
    countryCode;
}
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], AddressValidationResponseDto.prototype, "canBeAutoCorrected", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], AddressValidationResponseDto.prototype, "needsCorrection", void 0);
__decorate([
    IsObject(),
    Type(() => AddressValidationResponseComponent),
    __metadata("design:type", AddressValidationResponseComponent)
], AddressValidationResponseDto.prototype, "street", void 0);
__decorate([
    IsObject(),
    Type(() => AddressValidationResponseComponent),
    __metadata("design:type", AddressValidationResponseComponent)
], AddressValidationResponseDto.prototype, "zip", void 0);
__decorate([
    IsObject(),
    Type(() => AddressValidationResponseComponent),
    __metadata("design:type", AddressValidationResponseComponent)
], AddressValidationResponseDto.prototype, "town", void 0);
__decorate([
    IsObject(),
    Type(() => AddressValidationResponseComponent),
    __metadata("design:type", AddressValidationResponseComponent)
], AddressValidationResponseDto.prototype, "countryCode", void 0);
//# sourceMappingURL=address-validation-response.dto.js.map